import React from "react";

import { Icons, Text } from "@evvve/ui-kit";

import Link from "src/shared-features/Link";
import { changeDateFormat } from "src/helpers/date";

import NotificationTemplate from "../NotificationTemplate";

import { IAmSpeakerAtTheEventMessage } from "../../../types";

import styles from "./style.module.scss";

type Props = {
  message: IAmSpeakerAtTheEventMessage;
};

const IAmSpeakerAtTheEvent = ({ message }: Props) => (
  <NotificationTemplate>
    <div className={styles.info}>
      <Icons.Info color="tangerine1000" size="s" />
      <Text size="m" color="tangerine1000">
        {"I'm a speaker at the event"}
      </Text>
    </div>
    <Link
      className={styles.eventTitle}
      size="m"
      color="violet"
      to={`/catalog/event/${message.eventId}`}>
      {message.eventTitle}
    </Link>
    <div className={styles.section}>
      <Text className={styles.dateInscription} size="xs" color="grayscale800" as="p">Date</Text>
      <Text size="xs" color="grayscale800" as="p">{changeDateFormat(message.eventDate)}</Text>
    </div>
  </NotificationTemplate>
);

export default IAmSpeakerAtTheEvent;
